import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页", href: "#top" },
  { label: "可用入口", href: "#addresses" },
  { label: "新域名", href: "#domain" },
  { label: "使用指南", href: "#guide" },
  { label: "常见问题", href: "#faq" },
  { label: "关于本站", href: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-background-200 bg-background-50/90 backdrop-blur-md"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-base font-bold text-background-50">
            本
          </span>
          <span className="font-heading text-lg font-medium text-foreground-950">本子站导航</span>
        </a>
        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition hover:bg-background-100 hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
        </div>
        <div className="hidden md:block">
          <a
            href="#addresses"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            前往入口
          </a>
        </div>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-800 md:hidden"
          aria-label="菜单"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </nav>
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm text-foreground-800 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#addresses"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-3 py-2 text-center text-sm font-medium text-background-50"
            >
              前往入口
            </a>
          </div>
        </div>
      )}
    </header>
  );
}